// extracted by mini-css-extract-plugin
export default {"nav":"PageNav_nav__dSeCC","nav__button":"PageNav_nav__button__3iUXk","nav__button__icon":"PageNav_nav__button__icon__plRsC","nav__title":"PageNav_nav__title__6Dz2X"};